import styles from "../ReasonToBuy.module.scss";

const WAITROSE_LOGO_URL =
  "https://static.johnlewiscontent.com/v1/static/Waitrose_Type-Maximised-Colour-Corporate-Green";
const CLICK_AND_COLLECT_LOGO_URL =
  "https://static.johnlewiscontent.com/v1/static/Click-and-Collect";

export const WaitroseLogo = () => (
  <img
    src={WAITROSE_LOGO_URL}
    alt=""
    width={99}
    height={54}
    style={{ display: "block" }}
  />
);

export const ClickAndCollectLogo = () => (
  <img
    src={CLICK_AND_COLLECT_LOGO_URL}
    alt=""
    width={54}
    height={54}
    style={{ display: "block" }}
  />
);

export const ClickAndCollectCountdownCopy = ({
  timeLeft,
  collectFromTime,
}: {
  timeLeft: string;
  collectFromTime: string;
}) => (
  <>
    Order in the next <span className={styles.cardTime}>{timeLeft}</span> and
    collect in-store from {collectFromTime} tomorrow
  </>
);
